import { defineCustomElement } from '@tyler-components-web/core';
import { CardComponent } from './card';
export * from './card-constants';
export * from './card';
export function defineCardComponent() {
    defineCustomElement(CardComponent);
}
